export const SAGA_GET_PROVEEDOR = 'proveedoresReducer/SAGA_GET_PROVEEDOR';
export const SAGA_GET_PROVEEDORES = 'proveedoresReducer/SAGA_GET_PROVEEDORES';
export const SET_PROVEEDORES = 'proveedoresReducer/SET_PROVEEDORES';
export const SAVE_PROVEEDOR = 'proveedoresReducer/SAVE_PROVEEDOR';
export const SAGA_ELIMINAR_PROVEEDOR = 'proveedoresReducer/SAGA_ELIMINAR_PROVEEDOR';
export const SAGA_GET_PROVEEDOR_BY_CODIGO = 'proveedoresReducer/SAGA_GET_PROVEEDOR_BY_CODIGO';
export const SAGA_GET_PROVEEDOR_BY_NOMBRE = 'proveedoresReducer/SAGA_GET_PROVEEDOR_BY_NOMBRE';
export const SAGA_SAVE_PROVEEDOR = 'proveedoresReducer/SAGA_SAVE_PROVEEDOR';

export const sagaGetProveedor = (idProveedor) => ({
    type: SAGA_GET_PROVEEDOR,
    payload: { idProveedor }
});

export const sagaGetProveedores = (nombre) => ({
    type: SAGA_GET_PROVEEDORES,
    query: nombre,
});

export const setProveedores = (payload) => ({
    type: SET_PROVEEDORES,
    payload
});

export const saveProveedor = (payload) => ({
    type: SAVE_PROVEEDOR,
    payload
});

export const sagaEliminarProveedor = (idProveedor) => ({
    type: SAGA_ELIMINAR_PROVEEDOR,
    payload: { idProveedor }
});

export const sagaGetProveedorByCodigo = (codigo) => ({
    type: SAGA_GET_PROVEEDOR_BY_CODIGO,
    payload: { codigo }
});

export const sagaGetProveedorByNombre = (nombre) => ({
    type: SAGA_GET_PROVEEDOR_BY_NOMBRE,
    payload: { nombre }
});

export const sagaSaveProveedor = (payload) => ({
    type: SAGA_SAVE_PROVEEDOR,
    payload
});